import React, { useRef } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Upload } from 'lucide-react';

export function CsvImportDialog({ open, onOpenChange, onImport, importing }) {
  const fileRef = useRef(null);

  const handleFile = (e) => {
    const file = e.target.files?.[0];
    if (file) onImport(file);
    if (fileRef.current) fileRef.current.value = '';
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md rounded-none border-zinc-200" data-testid="import-dialog">
        <DialogHeader><DialogTitle className="text-xl font-bold tracking-tight flex items-center gap-2"><Upload size={20} /> Import Campaigns from CSV</DialogTitle></DialogHeader>
        <div className="space-y-4 mt-4">
          <div className="bg-zinc-50 border border-zinc-200 p-4 text-sm text-zinc-600 space-y-2">
            <p className="font-medium text-zinc-900">CSV Format</p>
            <p>Required columns: <span className="font-mono text-xs">name</span></p>
            <p>Optional: <span className="font-mono text-xs">client, buy_type, status, volume, price, currency, start_date, end_date, description</span></p>
            <p className="text-xs text-zinc-400">Client names are matched against existing clients.</p>
          </div>
          <div className="space-y-2">
            <Label className="text-xs font-medium tracking-[0.1em] uppercase text-zinc-500">Select CSV File</Label>
            <Input type="file" accept=".csv" ref={fileRef} onChange={handleFile} disabled={importing} className="rounded-none" data-testid="csv-file-input" />
          </div>
          {importing && <div className="flex items-center gap-2 text-sm text-zinc-500"><div className="w-4 h-4 border-2 border-zinc-300 border-t-zinc-900 rounded-full animate-spin" /> Importing...</div>}
        </div>
      </DialogContent>
    </Dialog>
  );
}
